import { render } from "./InvestmentAgreementRegistry.vue?vue&type=template&id=77ecaf1c&scoped=true"
import script from "./InvestmentAgreementRegistry.vue?vue&type=script&lang=js"
export * from "./InvestmentAgreementRegistry.vue?vue&type=script&lang=js"

import "./InvestmentAgreementRegistry.vue?vue&type=style&index=0&id=77ecaf1c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ecaf1c"]])

export default __exports__